import Image from '@jetshop/ui/Image';
import { transparentDataImg } from '@jetshop/ui/Image/Image';
import ProductLink from '@jetshop/ui/ProductLink';
import Badges from '@jetshop/ui/ProductList/Badges';
import React from 'react';
import { css } from 'react-emotion';
import { Price } from '../../Price';
import { theme } from '../../Theme';
import { useProductVariants } from '@jetshop/core/hooks/useProductVariants';
import { VariantWrapper } from '../ProductPage';
import { VariantSelector } from '../VariantSelector';
import { StyledButton } from './ProductPackage';
import t from '@jetshop/intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'react-emotion';
import { useFauxPricing } from './useFauxPricing';
import { InformationPopup } from './InformationPopup';

const wrapperStyling = css`
  font-size: 1rem;
  position: relative;
  list-style-type: none;
  width: 25%;
  min-width: 25%;
  scroll-snap-align: start;
  position: relative;
  /* padding: 1rem 1rem 2rem; */
  a {
    text-decoration: none;
    color: inherit;
    display: block;
    background: transparent;
    width: 100%;
  }

  .product-image-wrapper {
    border: none;
    /* padding: 5px; */
    background: white;
    width: 100%;
    picture {
      mix-blend-mode: multiply;
    }

    .no-product-image {
      > div {
        background: white !important;
        text-align: center;
      }
    }
  }

  .product-card-detail {
    background: transparent;
    padding: 0.75em 10px;
    line-height: 1.35;
    text-align: start;
    width: 100%;
    max-width: 50%;
    h3 {
      font-weight: 400;
      font-size: 12px;
      /* text-overflow: ellipsis; */
      /* white-space: nowrap; */
      /* overflow: hidden; */
      font-weight: normal;
      margin-bottom: 10px;
      text-transform: uppercase;
      ${theme.below.md} {
        font-size: 12px;
        white-space: initial;
        position: relative;

        //max-height: 33px;
        overflow: hidden;
        display: block;
        width: 100%;
        &:after {
          content: '';
          position: absolute;
          pointer-events: none;
          right: 0;
          height: 16px;
          width: 50px;
          bottom: -1px;
          background: -webkit-gradient(
            linear,
            left top,
            right top,
            from(hsla(0, 0%, 100%, 0)),
            to(#fff)
          );
          background: linear-gradient(90deg, hsla(0, 0%, 100%, 0), #fff);

          display: none;
        }
      }
    }

    h4 {
      font-weight: normal;
      font-size: 1em;
      color: ${theme.colors.black};
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
  .price-wrapper {
    font-weight: bold;
    font-size: 12px !important;
    & > div {
      display: flex;
      justify-content: start;
      margin: 0;
    }
    .new-price {
      font-size: 12px !important;
      color: #ff0000;
      margin-right: 8px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
    .old-price {
      font-size: 12px !important;
      color: #878787;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }

  ${theme.below.md} {
    font-size: 12px;
  }
  > div {
    margin: 0 5px;
  }

  button {
    max-width: 80%;
    margin: auto auto;
  }
  ${theme.below.xl} {
    width: 33.333%;
    min-width: 33.333%;
    padding: 1rem;
  }
  ${theme.below.lg} {
    width: 50%;
    min-width: 50%;
    padding: 1rem;
  }
  ${theme.below.md} {
    width: 100%;
    padding: 1rem;
  }
`;

const PackageCardVariantWrapper = styled('div')`
  [data-flight-dropdown-button] {
    max-width: 100%;
    margin: 0;
    padding: 0 !important;
    font-size: 12px;
    font-weight: normal !important;
    border: none !important;
  }

  .button-select-wrapper {
    margin-top: 10px;
    button {
      font-size: 12px;
      min-width: max-content;
      height: 24px;
      border: 1px solid black;
      margin-right: 5px;
      padding: 0 10px;
      /* overflow: hidden;
      text-overflow: ellipsis; */

      &.active {
        border: none;
      }
    }
  }
`;

export default function PackageCard({
  product,
  className,
  imageAspect = '3:4',
  imageSizes = [1 / 4, 1 / 3, 1 / 2, 1 / 2],
  forwardRef,
  as = 'div',
  children,
  selectedPackage,
  packageHandler,
  group,
  overview,
  upsell,
  information,
  ...linkProps
}) {
  const hasImages = product?.images && product?.images?.length > 0;
  const Tag = as;
  const inPackage =
    selectedPackage?.filter(
      (sel) => sel?.group === group && sel?.id === product?.id
    ).length > 0;
  const variantHandler = useProductVariants(
    product?.articleNumber ? product : undefined,
    { initialVariant: { values: ['Köps ihop med skida'] } }
  );

  const { fauxPrice } = useFauxPricing(product);

  const {
    selectedVariant: selectedVariation,
    validation: variantValidation,
    getMissingOptions,
  } = variantHandler;

  if (selectedVariation?.stockStatus?.buyable === false) {
    return null;
  }

  return (
    <Tag
      className="product-card"
      css={[wrapperStyling, className]}
      data-testid="product"
      data-product-card
      ref={forwardRef}
    >
      <ProductLink product={product} {...linkProps}>
        <div className="product-image-wrapper">
          {hasImages ? (
            <Image
              className="product-image"
              sizes={imageSizes}
              aspect={'4:3'}
              alt={product.images[0].alt}
              src={product.images[0].url}
            >
              <Badges badges={product.badges} />
            </Image>
          ) : (
            <Image
              className="no-product-image product-image"
              sizes={imageSizes}
              aspect={imageAspect}
              src={transparentDataImg}
            />
          )}
        </div>
      </ProductLink>
      <section className="product-card-detail">
        {information && <InformationPopup product={product} />}
        <header>
          <h3>{product.name}</h3>
        </header>
        <div className="price-wrapper">
          <Price
            price={fauxPrice ? fauxPrice : product.price}
            previousPrice={product.previousPrice}
          />
        </div>
        <PackageCardVariantWrapper>
          {/* <VariantSelector
            product={product}
            variantHandler={variantHandler}
            preselected={true}
            dropDownSelect={false}
          /> */}
        </PackageCardVariantWrapper>

        {upsell ? (
          <div></div>
        ) : (
          <StyledButton
            disabled={
              variantValidation === 'incomplete' ||
              variantValidation === 'outOfStock'
            }
            active={inPackage}
            onClick={() => {
              packageHandler(
                {
                  ...product,
                  mainProduct: product.articleNumber,
                  articleNumber: selectedVariation
                    ? selectedVariation.articleNumber
                    : product.articleNumber,
                  group: group,
                  variant: selectedVariation
                    ? selectedVariation.values.join()
                    : null,
                },
                !inPackage
              );

              if (
                overview.current &&
                typeof window !== 'undefined' &&
                typeof document !== 'undefined'
              ) {
                const topScroll =
                  overview.current.getBoundingClientRect().top +
                  document.documentElement.scrollTop -
                  150;
                window.scrollTo({ top: topScroll, behavior: 'smooth' });
              }
            }}
          >
            {variantValidation === 'incomplete' ? (
              t('Välj alternativ')
            ) : inPackage ? (
              <>
                <FontAwesomeIcon icon={['fal', 'check']} />
                {t('Tillagd i paketet')}
              </>
            ) : (
              t('Lägg i paketet')
            )}
          </StyledButton>
        )}
        {children}
      </section>
    </Tag>
  );
}
